import { render, staticRenderFns } from "./RoutePageHeader.vue?vue&type=template&id=09629b7c&scoped=true&"
import script from "./RoutePageHeader.vue?vue&type=script&lang=ts&"
export * from "./RoutePageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RoutePageHeader.vue?vue&type=style&index=0&id=09629b7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09629b7c",
  null
  
)

export default component.exports